import { createSlice } from "@reduxjs/toolkit";
import {
  addSaga,
  createAsyncSaga,
  createSagaReducer,
  persist,
  sagaSlice,
} from "./sagaStore";
import storeEmployees from "../services/fetchStoreEmployees";

interface LocationHistoryItem {
  latitude: string;
  longitude: string;
  createdAt: string;
  modifiedAt: string;
}

interface StoreEmployee {
  userId: number;
  userFirebaseId: string | null;
  shopId: string;
  name: string;
  email: string | null;
  phoneNumber: string | null;
  profilePicUrl: string | null;
  role:
    | "SHOP_PICKER"
    | "SHOP_DELIVERY"
    | "SHOP_SUPERVISOR"
    | "SHOP_CATALOG_EDITOR"
    | "SHOP_STOCK_MANAGER";
  config?: { allowedCategories?: string[] } | null;
  loginType?: "Email" | "Phone" | "Google" | null;
  status: "Registered" | "Invited" | "Deleted";
  locationHistory?: LocationHistoryItem[];
}

export interface StoreEmployeesResponse {
  storeEmployees: StoreEmployee[];
  supervisors: StoreEmployee[];
  totalAgents: number;
  totalSupervisors: number;
}

export interface AllStoreEmployeeState {
  list: {
    loading: boolean;
    error: string | null;
    data: StoreEmployeesResponse | null;
  };
}

const initialState: AllStoreEmployeeState = {
  list: {
    loading: false,
    error: null,
    data: null,
  },
};

const Slice: sagaSlice = createSlice({
  ...persist("allStoreEmployee", initialState),
  reducers: {
    ...createSagaReducer("fetchStoreEmployees", "list", {
      success: (state: AllStoreEmployeeState, action: any) => {
        // Extract the nested data structure: response.data.result.data
        const nestedData = action?.payload?.result?.data;
        state.list.data = nestedData || null;
      },
    }),
  },
});

const fetchAllStoreEmployees = createAsyncSaga(
  "fetchStoreEmployees",
  Slice,
  storeEmployees.fetchStoreEmployees,
  ["shopId"]
);

addSaga(Slice.actions.fetchStoreEmployees.type, fetchAllStoreEmployees);

export const { fetchStoreEmployees } = Slice.actions;

export default Slice.reducer;
